import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0079BF',
    },
    background: {
      default: '#F4F5F7',
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#0079BF',
    },
    background: {
      default: '#121212',
    },
  },
});
